const EmbedGoogleForm = ({ block }) => {
  if (!block) return null;
  const { primary } = block;

  return (
    <>
      <div className="form-wrapper">
        <div className="form">
          <iframe
            src={primary.link_on_form}
            frameBorder="0"
            style={{ width: '100%', height: '1280px' }}
            allowFullScreen
          ></iframe>
          <div className="overlay"></div>
        </div>
      </div>
      <style jsx>{`
        .form-wrapper {
          position: relative;
          margin-top: 50px;
          width: 100%;
          height: 1280px;
        }
        .form {
          width: 100%;
          height: 100%;
        }
        .overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 56px;
          background-color: #000;
          z-index: 1;
        }
        iframe {
          position: relative;
          z-index: 0;
        }
      `}</style>
    </>
  );
};

export default EmbedGoogleForm;